<template>
  <img
    alt="loading"
    src="@/assets/loader-small.svg"
    height="20">
</template>
